
//Helper Model to hold field errors info
var FieldErrorM = function(core) {
    this._core = core;
    this._errors = [];
};

FieldErrorM = function(core, errors) {
    this._core = core;
    this._errors = errors || [];
};

//returns an array of ready to use error messages[ {field: ...., errorMsg: ...}, {}..]
FieldErrorM.prototype.getTranslatedErrors = function() {
    return this._errors.map((err) => ({
       ...err,
       errorMsg: (this._core.translateString("field-error", err.type)
           // Visibility erros use the same type's, but with a prefix
           || this._core.translateString("field-error", err.type.replace('Visibility_', ''))
           || err.type)
    }));
};

FieldErrorM.prototype.hasErrors = function() {
    return this._errors.length > 0;
};

export default FieldErrorM;
